module.exports = __webpack_public_path__ + "img/14.35586400.webp";